import { Injectable } from "@angular/core";
import { Payload } from "src/app/services/utilities/utility.service";
import { Channel } from "src/app/models/ticket-plus/channel";
import { TicketPlusService } from "./ticket-plus.service";

@Injectable({
  providedIn: "root",
})
export class ChannelService extends TicketPlusService {
  private url = `/ticket-plus/channels`;

  async getChannels(params = {}): Promise<Payload> {
    return this.cacheService.getPayloadAndCache(this.url, params, this.utilityService);
  }

  async createUpdateChannel(channel: Channel): Promise<Channel> {
    this.cacheService.clearCache(this.url);
    return new Promise<Channel>((resolve) => {
      this.utilityService.sendRequest("POST", this.url, {}, channel).subscribe((payload) => {
        if (payload?.data?.length) {
          resolve(payload.data[0]);
        } else {
          resolve(null);
        }
      });
    });
  }

  async deleteChannel(channel: Channel): Promise<Payload> {
    this.cacheService.clearCache(this.url);
    return new Promise<Payload>((resolve) => {
      this.utilityService.sendRequest("DELETE", `${this.url}/${channel.id}`).subscribe((payload) => {
        resolve(payload);
      });
    });
  }
}
